import React from "react";
import config from '@/config/config';
import logoLarge from './../../images/logoLarge.png';
import logoSmall from './../../images/logoSmall.png';

export default class Logo extends React.Component {
  render() {
    let className = this.props.isHeading ? `headingLogo ${this.props.squeeze ? 'squeeze' : ''}` : "bwLogo";
    if (this.props.size == 'small') className += '-small';
    return (
      <a href={config.ApplicationRoutes.login}>
        <img className={className} alt="logo" src={this.props.isHeading ? logoLarge : logoSmall}/>
      </a>
    )
  }
}
